export const NAME = 'processingactivities';